import {Link} from 'react-router-dom'
import {IoStarSharp} from 'react-icons/io5'
import {MdLocationOn} from 'react-icons/md'
import {BsBriefcaseFill} from 'react-icons/bs'
import './index.css'

const JobItem = props => {
  const {jobItem} = props
  const {
    id,
    title,
    rating,
    companyLogoUrl,
    location,
    jobDescription,
    employmentType,
    packagePerAnnum,
  } = jobItem

  return (
    <Link className="job-item-nav-link" to={`/jobs/${id}`}>
      <li className="job-item-bg-container">
        <div className="company-details">
          <img
            alt="company logo"
            className="company-logo"
            src={companyLogoUrl}
          />
          <div>
            <h1 className="company-name">{title}</h1>
            <div className="rating-conainer">
              <IoStarSharp color="#fbbf24" size="30" />
              <p className="company-rating">{rating}</p>
            </div>
          </div>
        </div>
        <div className="company-location-details">
          <div className="center">
            <div className="center location-details">
              <MdLocationOn size="20" />
              <p className="location-item">{location}</p>
            </div>
            <div className="center">
              <BsBriefcaseFill size="20" />
              <p className="employment-item">{employmentType}</p>
            </div>
          </div>
          <p className="package-per-annum">{packagePerAnnum}</p>
        </div>
        <hr />
        <div className="description-container">
          <h1 className="description-header">Description</h1>
          <p className="job-description">{jobDescription}</p>
        </div>
      </li>
    </Link>
  )
}
export default JobItem
